import React, { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';

interface PageContainerProps {
  title?: string;
  blurb?: string;
  icon?: ReactNode;
  padded?: boolean;
  chip?: ReactNode;
  children: ReactNode;
}

function PageContainer({ title, chip, blurb, icon, children, padded = true }: PageContainerProps) {
  return (
    <Paper
      elevation={4}
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: 3,
        overflow: 'hidden',
        bgcolor: 'background.paper',
        mb: 3,
      }}
    >
      {title && (
        <Box
          sx={{
            px: { xs: 2.5, md: 3.5 },
            pt: { xs: 2.5, md: 3.5 },
            pb: 2.5,
            borderBottom: 1,
            borderColor: 'divider',
            bgcolor: 'background.paper',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.75 }}>
            {icon}

            <Box sx={{ minWidth: 0 }}>
              {chip}
              <Typography
                variant="h4"
                component="h1"
                sx={{
                  fontWeight: 900,
                  lineHeight: 1.15,
                }}
                data-testid="main-heading"
              >
                {title}
              </Typography>
              {blurb && (
                <Typography
                  variant="body1"
                  component="p"
                  color="text.secondary"
                  sx={{
                    mt: 0.75,
                    maxWidth: 780,
                  }}
                >
                  {blurb}
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      )}

      <Box sx={{ p: { xs: padded ? 2.5 : 0, md: padded ? 3.5 : 0 } }}>{children}</Box>
    </Paper>
  );
}

export default PageContainer;
